import type {HiddenProps} from './Hidden'
import {Hidden} from './Hidden'

export {Hidden} from './Hidden'
export type {HiddenProps}
export default Hidden
